<template lang="pug">
toolbar-button-group.AppChartZoom(
	v-if="true"
	label="Zoom"
)
	toolbar-button(
		v-for="z in zooms"
		@click="setExtremes(z, true)"
		:class="{ '-active': z === active }"
	) {{ z === 'A' ? 'All' : z+'Y' }}
</template>

<script>
import {differenceInSeconds, differenceInYears, subYears} from "date-fns";
import Highcharts from 'highcharts';
import ToolbarButton from "@/common/components/ToolbarButton.vue";
import ToolbarButtonGroup from "@/common/components/ToolbarButtonGroup.vue";

export default {
	components: {
		'toolbar-button' : ToolbarButton,
		'toolbar-button-group' : ToolbarButtonGroup,
	},
	props: {
		chart: {
			type: Object,
			default(){
				return null;
			}
		},
		zooms: {
			type: Array,
			default(){
				return [
					1,3,5,10,'A'
				]
			}
		},
		range: {
			type: Object
		}
	},

	data(){
		return {
			active: {
				type: String,
				default: 'A'
			}
		}
	},

	mounted(){
		Highcharts.addEvent(
				this.chart.xAxis[0],
				'afterSetExtremes',
				(e) => this.onAfterSetExtremes(e) );
		this.setExtremes(1);
	},

	watch : {
		chart(c){
			Highcharts.addEvent(
				c.xAxis[0],
				'afterSetExtremes',
				(e) => this.onAfterSetExtremes(e) );

			this.setExtremes(1);
		}
	},

	methods: {
		zoom( amount ){

		},

		onAfterSetExtremes( e ){
			const extremes = this.chart.xAxis[0].getExtremes();
			const min = new Date();
			const max = new Date();
			min.setTime(extremes.min);
			max.setTime(extremes.max);

			var years = differenceInYears(max, min);
			var seconds = differenceInSeconds(max, min);
			var series = this.chart.series[0];

			if( seconds == differenceInSeconds( series.data[series.data.length-1].date, series.data[0].date ) ){
				this.active = 'A';
			}
			else {
				this.active = Math.abs(years);
			}
		},

		setExtremes(v, animate){
			const series = this.chart.series[0];

			const last = series.data[series.data.length-1].date;
			let start;
			if( v === 'A' ){
				start = series.options.data[0].date;
			}
			else {
				start = subYears( last, v );
			}

			this.chart.xAxis[0].setExtremes( start.getTime(), last.getTime(), 1, animate );
		}
	}
}
</script>

<style lang="scss">
@use "@/common/scss/variables";
.AppChartZoom {
	.ToolbarButton {
		&:not(:first-child){
			padding-left: 0.45em;
		}
		&:not(:last-child){
			padding-right: 0.45em;
		}
		&.-active {
			color: variables.$color-green;
		}
	}
}
</style>